import type { CollectResult } from '@fraudeai/schema';
import { runCollector, type AnyCollectorModule, type CollectOptions } from './harness.js';

import { navigatorModule } from './modules/navigator.js';
import { screenModule } from './modules/screen.js';
import { localeModule } from './modules/locale.js';
import { canvasModule } from './modules/canvas.js';
import { webglModule } from './modules/webgl.js';
import { webgpuModule } from './modules/webgpu.js';
import { audioModule } from './modules/audio.js';
import { fontsModule } from './modules/fonts.js';
import { rectsModule } from './modules/rects.js';
import { contextsModule } from './modules/contexts.js';
import { nativesModule } from './modules/natives.js';
import { engineModule } from './modules/engine.js';
import { familyModule } from './modules/family.js';
import { invariantsModule } from './modules/invariants.js';
import { nativeCallsModule } from './modules/nativecalls.js';
import { automationModule } from './modules/automation.js';
import { osModule } from './modules/os.js';
import { storageModule } from './modules/storage.js';
import { mediaModule } from './modules/media.js';
import { geolocationModule } from './modules/geolocation.js';
import { permissionsModule } from './modules/permissions.js';
import { networkModule } from './modules/network.js';
import { coresModule } from './modules/cores.js';
import { probesModule } from './modules/probes.js';

/**
 * Реестр модулей.
 *
 * Фаза 0 — быстрые сигналы без зависимостей: они нужны остальным (разобранный
 * UA определяет, какие проверки вообще применимы). Фаза 1 идёт параллельно.
 */
export const MODULES: AnyCollectorModule[] = [
  navigatorModule,
  screenModule,
  localeModule,

  canvasModule,
  webglModule,
  webgpuModule,
  audioModule,
  fontsModule,
  rectsModule,
  contextsModule,
  nativesModule,
  engineModule,
  familyModule,
  invariantsModule,
  nativeCallsModule,
  automationModule,
  osModule,
  storageModule,
  mediaModule,
  geolocationModule,
  permissionsModule,
  networkModule,
  probesModule,
  coresModule,
];

/** Собирает все сигналы окружения. Скоринг выполняется отдельно. */
export function collect(options: CollectOptions = {}): Promise<CollectResult> {
  return runCollector(MODULES, options);
}

export { computeIdentity } from './identity.js';
export { rememberVisit } from './modules/storage.js';
export { contextProbe } from './probe/contextProbe.js';
export { parseUserAgent, expectedJsEngine, platformFamilyOf, uaDataPlatformFamily } from './util/ua.js';
export { hash, hashValue, stableStringify, shortHash } from './util/hash.js';
export type { CollectOptions, AnyCollectorModule, ModuleContext } from './harness.js';
